import { authorizedAxios } from '../config/axios';

export const getServicesAndSubcategoriesByCategoryIds = params =>
  authorizedAxios.get(`/api/v1/services-and-subcategories`, { params });

export const getServiceCategories = params =>
  authorizedAxios.get(`/api/v1/get-set-up-categories`, { params });
